<template>
  <div>
    <v-select
      v-model="inputedValue"
      item-text="label"
      item-value="value"
      :items="items"
      dense
      outlined
      return-object
      class="original-selectbox"
      hide-details
      :placeholder="$t('common.input_unselected_2')"
      :height="height"
      width="80%"
      clearable
    >
    </v-select>
  </div>
</template>

<script>
export default {
  components: {
    //
  },
  props: {
    value: {},
    type: { type: Number, default: 0 },
    height: { default: '32px' }
  },
  computed: {
    items() {
      let items = [
        { label: this.$t('order.order_unfinished'), value: 1 },
        { label: this.$t('order.order_complete'), value: 2 }
      ]
      switch (this.type) {
        case 1:
          items = [
            {
              label: this.$t('common.common_not-complete-this-time'),
              value: 1
            },
            { label: this.$t('order.order_complete'), value: 2 },
            {
              label: this.$t('common.common_not-complete-one-day'),
              value: 3
            }
          ]
          break
        case 2:
          items = [
            { label: this.$t('order.order_unfinished'), value: 1 },
            { label: this.$t('order.order_complete'), value: 2 },
            { label: this.$t('ship.ship_already-ship'), value: 3 },
            { label: this.$t('storage.storage_arrived'), value: 4 }
          ]
          break
      }
      return items
    },
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
